import { ILogAppender } from './ILogAppender'
import { LogLevel } from './LogLevel'

export class LoggerConfig {
  constructor(private appenders: ILogAppender[] = [], private level: LogLevel = LogLevel.INFO) {}

  public addAppender(appender: ILogAppender): void {
    this.appenders.push(appender)
  }
  public getAppenders(): ILogAppender[] {
    return this.appenders
  }

  public setLevel(level: LogLevel): void {
    this.level = level
  }

  public getLevel(): LogLevel {
    return this.level
  }
}
